import type { AuthResource } from '@labrav/react-components'
import { RootState } from '../../store'
import type { AuthorizationSource } from '../modules/authorization/reducer'
import { AppScope } from './authorizationModel'

export type { AuthResource }
export type { AuthorizationSource }

/**
 * Roles vs scopes vs capabilities
 * - Roles: legacy staff/partner identity roles from `roles.ts` (ADMIN/SUPER_ADMIN/etc).
 * - Scopes: JWT-granted product permissions (cloud/service/operation).
 */

export const selectScopes = (state: RootState): AppScope[] => {
  return state.authorization.scopes
}

/** Auth entry: Auth0, HubSpot JWT-in-URL, or Salesforce Canvas — mapped to Segment `labra_auth_provider`. */
export const selectAuthSource = (
  state: RootState
): AuthorizationSource | null => state.authorization.source

export const selectPolicyReady = (state: RootState): boolean =>
  state.authorization.policyLoadStatus === 'ready'

export const selectPolicyLoading = (state: RootState): boolean =>
  state.authorization.policyLoadStatus === 'loading'

export const selectHasScope =
  (scope: AppScope) =>
  (state: RootState): boolean =>
    selectScopes(state).includes(scope)
